'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var _objectWithoutProperties = require('@babel/runtime/helpers/objectWithoutProperties');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefault(_defineProperty);
var _objectWithoutProperties__default = /*#__PURE__*/_interopDefault(_objectWithoutProperties);

var _excluded = ["title"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty__default.default(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SocialYouTubeIcon = function SocialYouTubeIcon(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'YouTube' : _ref$title,
    props = _objectWithoutProperties__default.default(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsxs("svg", _objectSpread(_objectSpread({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    title: title,
    role: "img"
  }, props), {}, {
    children: [/*#__PURE__*/jsxRuntime.jsx("title", {
      children: title
    }), /*#__PURE__*/jsxRuntime.jsx("path", {
      d: "M21.5820455,7.20034091 C22,8.77011364 22,12.0454545 22,12.0454545 C22,12.0454545 22,15.3206818 21.5820455,16.8905682 C21.3520455,17.7567045 20.6743182,18.43875 19.8138636,18.6703409 C18.2542045,19.0909091 12,19.0909091 12,19.0909091 C12,19.0909091 5.74579545,19.0909091 4.18613636,18.6703409 C3.32568182,18.43875 2.64795455,17.7567045 2.41795455,16.8905682 C2,15.3206818 2,12.0454545 2,12.0454545 C2,12.0454545 2,8.77011364 2.41795455,7.20034091 C2.64795455,6.33420455 3.32568182,5.65215909 4.18613636,5.42068182 C5.74579545,5 12,5 12,5 C12,5 18.2542045,5 19.8138636,5.42068182 C20.6743182,5.65215909 21.3520455,6.33420455 21.5820455,7.20034091 Z M9.95454545,15.0192045 L15.1818182,12.0455682 L9.95454545,9.07170455 L9.95454545,15.0192045 Z"
    })]
  }));
};
SocialYouTubeIcon.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "SocialYouTubeIcon",
  "props": {
    "title": {
      "defaultValue": {
        "value": "'YouTube'",
        "computed": false
      },
      "required": false
    }
  }
};
var SocialYouTubeIcon$1 = SocialYouTubeIcon;

exports.default = SocialYouTubeIcon$1;
//# sourceMappingURL=SocialYouTubeIcon.js.map
